import { useFormik } from "formik";
import React, { useState } from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setMembersMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addMembers, updateMembers } from "services/membersService";
import { Constant } from "template/Constant";
import * as yup from 'yup';

import bloodGroup from "../../data/bloodgroup.json";
import designation from "../../data/designation.json";
import designation_basti from "../../data/designation_basti.json";
import designation_upamandal from "../../data/designation_upamandal.json";
import designationLevel from "../../data/designationLevel.json";
import vibhag from "../../data/vibhag.json";
import jillas from "../../data/jilla.json";
import nagars from "../../data/nagar.json";
import upamandal from "../../data/upamandal.json";
import basti from "../../data/basti.json";

const generalStyles = {
    marginTop: '3%'
}

type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const MembersForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const [isPreview, setIsPreview] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [button_name, setButtonName] = useState('Next')
    const prabhariTypes = {
        JILLA: "J",
        NAGAR_KHANDA: "NK",
        UPAMANDAL_BASTI: "UB",
        NONE: "NONE"
    }

    const dispatch = useAppDispatch();
    const iValue = { member_id: 0, member_name: '', mobile_number: '', age: '', desig_level_id: '', designation_id: '', address: '', pincode: '', vibhag_id: 0, zill_id: 0, nagar_khanda_id: 0, upamandal_basti_id: 0, login_otp: '', email: '', prabhari_id: 0, prabhari_type: prabhariTypes.NONE };
    const initialValue = action === 'edit' ? JSON.parse(JSON.stringify(row)) : iValue;


    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values, { resetForm }) => {
            console.log(action)
            if (action === 'edit') {
                setEditMode(true)
            } else {
                setEditMode(false)
            }

            var is_all_data_valid = true;
            if ((action == 'add' || action == 'edit') && button_name == "Next") {

                if (values.desig_level_id == '3') {
                    if (values.vibhag_id == 0) {
                        is_all_data_valid = false;
                    }
                }
                else if (values.desig_level_id == '4') {
                    if (values.zill_id == 0) {
                        is_all_data_valid = false;
                    }
                }
                else if (values.desig_level_id == '5') {
                    if (values.nagar_khanda_id == 0) {
                        is_all_data_valid = false;
                    }
                }
                else if (values.desig_level_id == '6' || values.desig_level_id == '7') {
                    if (values.upamandal_basti_id == 0) {
                        is_all_data_valid = false;
                    }
                }
                if (is_all_data_valid) {
                    hideShowForm('preview')
                    setIsPreview(true)
                    setButtonName("Submit")
                    alert('మీ డాటాను మాకు సబ్మిట్ చేసే ముందు ఒక సారి సరిగ్గా ఉన్నాయా లేదా చేక్ చేస్కోండి. సరిగ్గా ఉంటె సబ్మిట్ బటన్ ప్రెస్ చెయ్యండి. \n Before submission of data, please check once. If everything is okay, press SUBMIT');
                }
                else {
                    alert('Please fill all mandatory fields \n ఎర్ర రంగు స్టార్ వున్న అన్ని ఫీల్డ్స్ ని ఫిల్ చేయండి');
                }
            }
            else if (action == 'preview' && button_name == "Submit") {
                console.log("submission")
                if (values.desig_level_id == '3') {
                    values["prabhari_type"] = prabhariTypes.JILLA
                }
                else if (values.desig_level_id == '4') {
                    values["prabhari_type"] = prabhariTypes.NAGAR_KHANDA
                }
                else if (values.desig_level_id == '5') {
                    values["prabhari_type"] = prabhariTypes.UPAMANDAL_BASTI
                }
                else {
                    values["prabhari_type"] = prabhariTypes.NONE
                }

                const response = editMode ? await updateData(values) : await addMembers(values);
                if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setMembersMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    
                    resetForm({ values: iValue })
                    handleEdit();
                    console.log("response", response);
                    alert(response.data.message);
                    hideShowForm('');
                } else {
                    dispatch(setMembersMessage("Some error occured!"));
                    handleEdit();
                    alert(response['message']);
                }
            }
        },
        validationSchema: yup.object({
            member_name: yup.string().required('Name is required'),
            mobile_number: yup.string().length(10, "Mobile number should be 10 digits").required('Mobile number is required').matches(/^[6-9]\d{9}$/, "Please enter valid mobile number"),
            age: yup.number().moreThan(15, 'Age should be more than 15').lessThan(100, 'Age should be less than 100').required('Age is required'),
            desig_level_id: yup.number().moreThan(0, 'Badhyata Sthayi is required').required('Badhyata Sthayi is required'),
            designation_id: yup.number().moreThan(0, 'Badhyata is required').required('Badhyata is required'),
            address: yup.string().min(10, "Please enter full postal address").max(100, "Address should be less than 100 characters").required('Address is required'),
            pincode: yup.string().length(6, "Pincode should have 6 digits").required('Pincode is required').matches(/^[5]\d{5}$/, "Please enter valid pin code"),
            vibhag_id: yup.number().when('desig_level_id', {
                is: '3', then: yup.number().moreThan(0, "Vibhag is required").required('Vibhag is required')
            }),
            zill_id: yup.number().when('desig_level_id', {
                is: (desig_level_id) => desig_level_id >= 4,
                then: yup.number().moreThan(0, 'Jilla is required')
            }),
            nagar_khanda_id: yup.number().when('desig_level_id', {
                is: (desig_level_id) => desig_level_id >= 5,
                then: yup.number().moreThan(0, 'Nagara/Khanda is required')
            }),
            upamandal_basti_id: yup.number().when('desig_level_id', {
                is: (desig_level_id) => desig_level_id >= 6,
                then: yup.number().moreThan(0, 'Upamandal-basti is required')
            }),
            login_otp: yup.string().length(4, "Enter 4 digit login pin").required("Enter 4 digit login pin"),

        }),
    });

    const updateData = async (values) => {
        let updateValues = JSON.parse(JSON.stringify(values));
        delete updateValues.desig_level_name
        delete updateValues.designation_name
        return await updateMembers(updateValues)

    }

    const handleEdit = () => {
        console.log('inside')
        editMode ? hideShowForm('edit'): hideShowForm('add')
        setIsPreview(false)
        setButtonName("Next")
        console.log(formik.values)

    }
    return (
        <Card className="shadow mb-4">
            <Card.Body>
                <Form onSubmit={formik.handleSubmit} aria-disabled={isPreview}>
                    <fieldset disabled={isPreview}>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>పేరు / Name<span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control type="text" name="member_name" className="form-control" value={formik.values.member_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.touched.member_name && !!formik.errors.member_name}
                                isValid={!!formik.touched.member_name && !formik.errors.member_name}
                            ></Form.Control>
                            {
                                formik.errors.member_name && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.member_name}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>వయసు	/ Age<span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control type="number" name="age" className="form-control" value={formik.values.age}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                inputMode="numeric"
                                isInvalid={!!formik.touched.age && !!formik.errors.age}
                                isValid={!!formik.touched.age && !formik.errors.age}
                            ></Form.Control>
                            {
                                formik.errors.age && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.age}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>

                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>
                                మొబైల్ నెంబర్ / Mobile Number<span className="text-danger font-weight-bold"> *</span> </label>
                            <Form.Control type="number" name="mobile_number" className="form-control" value={formik.values.mobile_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                inputMode="numeric"
                                isInvalid={!!formik.touched.mobile_number && !!formik.errors.mobile_number}
                                isValid={!!formik.touched.mobile_number && !formik.errors.mobile_number}
                            ></Form.Control>
                            {
                                formik.errors.mobile_number && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.mobile_number}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>మీ 4 అంకెల లాగిన్ పిన్(దీనిని గుర్తుపెట్టుకోండి) / Your 4 Digits Login PIN(Please Remember This)
                                <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control type="text" name="login_otp" className="form-control" value={formik.values.login_otp}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                onKeyDown={event => {
                                    // console.log("event", event);
                                    if (event.key == "0" || event.key == "1" || event.key == "2" || event.key == "3" || event.key == "4" ||
                                        event.key == "5" || event.key == "6" || event.key == "7" || event.key == "8" ||
                                        event.key == "9" || event.key == "Backspace" || event.key == "ArrowLeft" ||
                                        event.key == "ArrowRight" || event.key == "Delete" || event.key == "Tab") {

                                        //event.preventDefault();

                                        return true;
                                    }
                                    else {
                                        event.preventDefault();


                                        return false;
                                    }
                                }}
                                isInvalid={!!formik.touched.login_otp && !!formik.errors.login_otp}
                                isValid={!!formik.touched.login_otp && !formik.errors.login_otp}
                            ></Form.Control>
                            {
                                formik.errors.login_otp && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.login_otp}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>ఇ-మెయిల్ / e-mail</label>
                            <Form.Control type="text" name="email" className="form-control" value={formik.values.email}
                                onChange={formik.handleChange}
                            ></Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>పూర్తి పోస్టల్ చిరునామా / Full Postal Address
                                <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control type="text" name="address" className="form-control" value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.touched.address && !!formik.errors.address}
                                isValid={!!formik.touched.address && !formik.errors.address}
                            ></Form.Control>
                            {
                                formik.errors.address && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.address}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>పోస్టల్ పిన్ కోడ్  / Postal PinCode
                                <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control type="text" name="pincode" className="form-control" value={formik.values.pincode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                inputMode="numeric"
                                isInvalid={!!formik.touched.pincode && !!formik.errors.pincode}
                                isValid={!!formik.touched.pincode && !formik.errors.pincode}
                            ></Form.Control>
                            {
                                formik.errors.pincode && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.pincode}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>భాద్యత స్థాయి / Badhyata Sthayi
                                <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control
                                as="select"
                                name="desig_level_id"
                                value={formik.values.desig_level_id}
                                onChange={e => {
                                    formik.values.vibhag_id = 0
                                    formik.values.zill_id = 0
                                    formik.values.nagar_khanda_id = 0
                                    formik.values.upamandal_basti_id = 0
                                    formik.handleChange(e)
                                }}
                                onBlur={formik.handleBlur}
                                className="form-control"
                                isInvalid={!!formik.touched.desig_level_id && !!formik.errors.desig_level_id}
                                isValid={!!formik.touched.desig_level_id && !formik.errors.desig_level_id}>
                                <option value="">-- Select Badhyata Sthayi --</option>
                                {designationLevel.map((level) => {
                                    return <option key={level.desig_level_id} value={level.desig_level_id}>{level.desig_level_name}</option>
                                })}

                            </Form.Control>
                            {
                                formik.errors.vibhag_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.vibhag_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>


                        {(
                            formik.values.desig_level_id == '3' ||
                            formik.values.desig_level_id == '4' ||
                            formik.values.desig_level_id == '5' ||
                            formik.values.desig_level_id == '6' ||
                            formik.values.desig_level_id == '7'
                        ) &&
                            <Form.Group>
                                <label className="form -control-label" style={generalStyles}>విభాగ్ / Vibhag
                                    <span className="text-danger font-weight-bold"> *</span></label>
                                <Form.Control
                                    as="select"
                                    name="vibhag_id"
                                    value={formik.values.vibhag_id}
                                    onChange={e => {
                                        formik.values.zill_id = 0
                                        formik.values.nagar_khanda_id = 0
                                        formik.values.upamandal_basti_id = 0
                                        formik.handleChange(e)
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control"
                                    isInvalid={!!formik.touched.vibhag_id && !!formik.errors.vibhag_id}
                                    isValid={!!formik.touched.vibhag_id && !formik.errors.vibhag_id}>
                                    <option value="">-- Select Vibhag --</option>
                                    {vibhag.map((level) => {
                                        return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                                    })}

                                </Form.Control>
                                {
                                    formik.errors.vibhag_id && (
                                        <Form.Control.Feedback type="invalid">
                                            <>{formik.errors.vibhag_id}</>
                                        </Form.Control.Feedback>
                                    )}
                            </Form.Group>}
                        {(
                            formik.values.desig_level_id == '4' ||
                            formik.values.desig_level_id == '5' ||
                            formik.values.desig_level_id == '6' ||
                            formik.values.desig_level_id == '7'
                        ) &&
                            <Form.Group>
                                <label className="form -control-label" style={generalStyles}>జిల్లా / Jilla
                                    <span className="text-danger font-weight-bold"> *</span></label>
                                <Form.Control
                                    as="select"
                                    name="zill_id"
                                    value={formik.values.zill_id}
                                    onChange={e => {
                                        formik.values.nagar_khanda_id = 0
                                        formik.values.upamandal_basti_id = 0
                                        formik.handleChange(e)
                                    }}
                                    onBlur={formik.handleBlur}

                                    className="form-control"
                                    isInvalid={!!formik.touched.zill_id && !!formik.errors.zill_id}
                                    isValid={!!formik.touched.zill_id && !formik.errors.zill_id}>
                                    <option value="">-- Select Jilla --</option>
                                    {jillas.map((jilla) => {
                                        if (jilla.vibhag_id == formik.values.vibhag_id) {
                                            return jilla.jillas.map(level => {
                                                return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                            })
                                        }

                                    })}

                                </Form.Control>
                                {
                                    formik.errors.zill_id && (
                                        <Form.Control.Feedback type="invalid">
                                            <>{formik.errors.zill_id}</>
                                        </Form.Control.Feedback>
                                    )}
                            </Form.Group>}
                        {(
                            formik.values.desig_level_id == '5' ||
                            formik.values.desig_level_id == '6' ||
                            formik.values.desig_level_id == '7'
                        ) &&
                            <Form.Group>
                                <label className="form -control-label" style={generalStyles}>
                                    ఖండ/నగర్ - Khanda/Nagar
                                    <span className="text-danger font-weight-bold"> *</span></label>
                                <Form.Control
                                    as="select"
                                    name="nagar_khanda_id"
                                    value={formik.values.nagar_khanda_id}
                                    onChange={e => {
                                        formik.values.upamandal_basti_id = 0
                                        formik.handleChange(e)
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control"
                                    isInvalid={!!formik.touched.nagar_khanda_id && !!formik.errors.nagar_khanda_id}
                                    isValid={!!formik.touched.nagar_khanda_id && !formik.errors.nagar_khanda_id}
                                >
                                    <option value="">-- Select Khanda/Nagar --</option>
                                    {nagars.map((nagar) => {
                                        if (nagar.jilla_id == formik.values.zill_id) {
                                            return nagar.nagar.map(level => {
                                                return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                                            })
                                        }

                                    })}

                                </Form.Control>
                                {
                                    formik.errors.nagar_khanda_id && (
                                        <Form.Control.Feedback type="invalid">
                                            <>{formik.errors.nagar_khanda_id}</>
                                        </Form.Control.Feedback>
                                    )}
                            </Form.Group>}
                        {(formik.values.desig_level_id == '6' || formik.values.desig_level_id == '7') &&
                            <Form.Group>
                                <label className="form -control-label" style={generalStyles}>
                                    ఉపమండలం/ బస్తీ - Upamandal/Basti
                                    <span className="text-danger font-weight-bold"> *</span></label>
                                <Form.Control
                                    as="select"
                                    name="upamandal_basti_id"
                                    value={formik.values.upamandal_basti_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="form-control"
                                    isInvalid={!!formik.touched.upamandal_basti_id && !!formik.errors.upamandal_basti_id}
                                    isValid={!!formik.touched.upamandal_basti_id && !formik.errors.nagar_khanda_id}
                                >
                                    <option value="">-- Select Upamandal-Basti --</option>

                                    {formik.values.desig_level_id == '6' ? upamandal.map((upamandal_basti) => {
                                        if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                            return upamandal_basti.upamandal_bastis.map(level => {
                                                return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                                            })

                                        }
                                        else { <option value=''>No Data Found</option> }

                                    })
                                        :
                                        formik.values.desig_level_id == '7' ? basti.map((upamandal_basti) => {
                                            if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                                return upamandal_basti.upamandal_bastis.map(level => {
                                                    return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Basti"}</option>
                                                })
                                            }
                                            else { <option value=''>No Data Found</option> }

                                        }) : ""



                                    }

                                </Form.Control>
                                {
                                    formik.errors.upamandal_basti_id && (
                                        <Form.Control.Feedback type="invalid">
                                            <>{formik.errors.upamandal_basti_id}</>
                                        </Form.Control.Feedback>
                                    )}
                            </Form.Group>}
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>బాధ్యత / Badhyata
                                <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control
                                as="select"
                                name="designation_id"
                                value={formik.values.designation_id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="form-control"
                                isInvalid={!!formik.touched.designation_id && !!formik.errors.designation_id}
                                isValid={!!formik.touched.designation_id && !formik.errors.designation_id}>
                                <option value="">-- Select Badhyata --</option>
                                {formik.values.desig_level_id == '6' ?
                                    (
                                        designation_upamandal.map((level) => {
                                            return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                                        })) :
                                    (formik.values.desig_level_id == '7' ?
                                        (
                                            designation_basti.map((level) => {
                                                return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                                            })) :

                                        (
                                            designation.map((level) => {
                                                return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                                            })))
                                }


                            </Form.Control>
                            {
                                formik.errors.designation_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.designation_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        {(formik.values.desig_level_id == '3' ||
                            formik.values.desig_level_id == '4' ||
                            formik.values.desig_level_id == '5') && (
                                <Form.Group>
                                    <label className="form -control-label" style={generalStyles}>మీ దత్తత / Your Prabhari
                                        <span className="text-danger font-weight-bold"> *</span></label>
                                    <Form.Control
                                        as="select"
                                        name="prabhari_id"
                                        value={formik.values.prabhari_id}
                                        onChange={formik.handleChange}
                                        className="form-control">
                                        <option value="">-- Select Your Prabhari --</option>
                                        {formik.values.desig_level_id == '3' &&
                                            jillas.map((jilla) => {
                                                if (jilla.vibhag_id == formik.values.vibhag_id) {
                                                    return jilla.jillas.map(level => {
                                                        return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                                    })
                                                }

                                            })
                                        }
                                        {formik.values.desig_level_id == '4' &&
                                            nagars.map((nagar) => {
                                                if (nagar.jilla_id == formik.values.zill_id) {
                                                    return nagar.nagar.map(level => {
                                                        return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                                                    })
                                                }

                                            })
                                        }
                                        {formik.values.desig_level_id == '5' &&
                                            [upamandal.map((upamandal_basti) => {
                                                if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                                    return upamandal_basti.upamandal_bastis.map(level => {
                                                        return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                                                    })
                                                }

                                            }),
                                            basti.map((upamandal_basti) => {
                                                if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                                    return upamandal_basti.upamandal_bastis.map(level => {
                                                        return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Basti"}</option>
                                                    })
                                                }
                                                else { <option value=''>No Data Found</option> }

                                            })
                                            ]
                                        }
                                        <option value="-1">ఏదీ లేదు / Don't Have</option>
                                    </Form.Control>
                                    {
                                        formik.errors.designation_id && (
                                            <Form.Control.Feedback type="invalid">
                                                <>{formik.errors.designation_id}</>
                                            </Form.Control.Feedback>
                                        )}
                                </Form.Group>
                            )}
                    </fieldset>
                    <Form.Group>
                        {isPreview && <Button className="float-left" variant="primary" style={generalStyles} onClick={handleEdit}>Edit</Button>}
                        <Button type="submit" className="float-right" variant="primary" style={generalStyles}>{button_name}</Button>
                    </Form.Group>
                </Form>

            </Card.Body>
        </Card>
    );
}
